export function replaceTokens(text, values) {
  return text.replace(/lf_([A-Za-z]{1,})/g, (match, token) => {
      return values[token.trim()] !== undefined ? values[token.trim()] : match;
  });
};
